const TopUp = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_827_15649)">
      <path
        d="M21.2259 0.5V-0.75H18.7259V0.5H21.2259ZM19.9759 
        19.5L19.1463 20.435L19.9731 21.1687L20.8024 20.4378L19.9759 19.5ZM27.8265 14.2473C28.3444 
        13.7908 28.3942 13.001 27.9378 12.483C27.4813 11.9651 26.6914 11.9153 26.1735 12.3717L27.8265 
        14.2473ZM13.8297 12.3746C13.3133 11.9164 12.5233 11.9635 12.065 12.4798C11.6068 12.9962 11.654 
        13.7863 12.1703 14.2445L13.8297 12.3746ZM18.7259 0.5V19.5H21.2259V0.5H18.7259ZM20.8024 20.4378L27.8265 
        14.2473L26.1735 12.3717L19.1495 18.5622L20.8024 20.4378ZM20.8056 18.565L13.8297 12.3746L12.1703 14.2445L19.1463 
        20.435L20.8056 18.565Z"
        fill="white"
      />
      <path
        d="M4 35C4 32.2386 6.23858 30 9 30H31C33.7614 30 36 32.2386 36 35V40H4V35Z"
        fill="url(#paint0_linear_827_15649)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_827_15649"
        x1="20"
        y1="30"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_827_15649">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TopUp;
